import {
    DotsHorizontalIcon
} from '@radix-ui/react-icons';
import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";
import { useContext, useMemo, useState } from 'react';
import { Link } from 'react-router';
import '../../App.css';
import { AuthContext } from '../../context/AuthContext';
import DeleteCupDialog from '../dialogs/deleteCupDialog';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import {
    Dialog,
} from "../ui/dialog";
import {
    DropdownMenu,
    DropdownMenuContent, DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from "../ui/dropdown-menu";
import { DataTable } from './datatable';
import DatatableSortButton from './datatableSortButton';

export const columns = (competition, auth, dataLength) => {
    const isAdminOrPrivilegedUser = auth?.user?.superadmin || (auth?.user?.roleInClub == 'admin' && auth?.user?.memberOfClub == parseInt(competition.club.id));

    const baseColumns = [
        {
            accessorKey: "name",
            header: ({ column }) => <DatatableSortButton column={column}>Cupnamn</DatatableSortButton>,
            cell: info => {
                const cup = info.row.original;
                return <>
                    <Link to={`cup/${cup.id}`} className='text-blue-600 font-medium hover:underline mr-2'>{cup.name}</Link>
                    {cup.finished_at && (<Badge variant='secondary'>Avslutad</Badge>)}
                </>
            }
        },
        {
            accessorKey: "uniqueBunnies",
            header: ({ column }) => <DatatableSortButton column={column}>Antal cupstarter</DatatableSortButton>,
        },
    ];

    if (isAdminOrPrivilegedUser && dataLength > 0) {
        baseColumns.push({
            id: "actions",
            enableHiding: false,
            cell: ({ row }) => {
                const cup = row.original;
                return (
                    <Dialog modal={true}>
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button variant="ghost" className="h-8 w-8 p-0 float-right">
                                    <span className="sr-only">Öppna meny</span>
                                    <DotsHorizontalIcon className="h-4 w-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end" onCloseAutoFocus={(e) => {
                                e.preventDefault();
                            }}>
                                <DropdownMenuLabel>Alternativ</DropdownMenuLabel>
                                <DropdownMenuSeparator />
                                <DeleteCupDialog cupId={cup.id} />
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </Dialog>
                );
            }
        });
    }
    return baseColumns;
};

export function CompetitionCupsDatatable({ competition, isLoading }) {
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);
    const { auth } = useContext(AuthContext)

    const filteredCups = useMemo(() => {
        return competition.cups.filter(cup => !cup.deleted_at); // Exclude cups with 'deleted_at'
    }, [competition.cups]);

    // Memoize the columns definition
    const tableColumns = useMemo(() => columns(competition, auth, filteredCups.length), [competition, auth, filteredCups.length]);

    const table = useReactTable({
        data: filteredCups,
        columns: tableColumns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting,
            columnFilters,
        },
    });

    return (
        <DataTable
            table={table}
            isLoading={isLoading}
            columns={tableColumns}
        />
    );
}
